import { useTranslation } from "react-i18next";
import { cn } from "../../lib/utils";
import { useEffect, useState } from "react";
import axios from "axios";

type Emirate = {
    id: string;
    name: string;
};

interface SelectTerritoryProps {
    territory: string | null;
    setTerritory: (code: string) => void;
    setIsTerritorySelecting: (isSelecting: boolean) => void;
    setTerritoryName: (name: string) => void;
}

export const SelectTerritory: React.FC<SelectTerritoryProps> = ({
    territory,
    setTerritory,
    setIsTerritorySelecting,
    setTerritoryName,
}) => {
    const { t } = useTranslation();
    const [emirates, setEmirates] = useState<Emirate[]>([]);

    useEffect(() => {
        const fetchEmirates = async () => {
            try {
                const response = await axios.get("/emirates");
                setEmirates(response.data.data);
            } catch (error) {
                console.error("Failed to fetch emirates:", error);
            }
        };

        fetchEmirates();
    }, []);

    return (
        <>
            <span className="mb-8 text-2xl font-medium text-foreground">
                {t("modals.select-territory")}
            </span>
            <div className="scroll flex max-h-[60vh] flex-col gap-y-3 overflow-y-auto pr-[3px]">
                {Array.isArray(emirates) &&
                    emirates.map((emirate) => (
                        <button
                            key={emirate.id}
                            className={cn(
                                "mb-4 flex items-center justify-start rounded-xl border-[0.5px] border-[rgba(229,229,229,0.9)] px-4 py-[18px] font-light text-[rgba(41,48,50,1)] transition hover:opacity-80 rtl:flex-row-reverse",
                                {
                                    "border border-primary shadow-[0px_2px_4px_0px_rgba(74,74,74,0.1)]":
                                        emirate.id === territory,
                                },
                            )}
                            onClick={() => {
                                setTerritory(emirate.id);
                                setTerritoryName(emirate.name);
                                setIsTerritorySelecting(false);
                            }}
                        >
                            {/* Location Pin SVG */}
                            <svg
                                width="18"
                                height="19"
                                viewBox="0 0 18 19"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M9.00016 10.5745C10.2925 10.5745 11.3402 9.52688 11.3402 8.23453C11.3402 6.94219 10.2925 5.89453 9.00016 5.89453C7.70781 5.89453 6.66016 6.94219 6.66016 8.23453C6.66016 9.52688 7.70781 10.5745 9.00016 10.5745Z"
                                    stroke="#525252"
                                />
                                <path
                                    d="M2.71527 6.8675C4.19277 0.372502 13.8153 0.380002 15.2853 6.875C16.1478 10.685 13.7778 13.91 11.7003 15.905C10.1928 17.36 7.80777 17.36 6.29277 15.905C4.22277 13.91 1.85277 10.6775 2.71527 6.8675Z"
                                    stroke="#525252"
                                />
                            </svg>
                            <span>{emirate.name}</span>
                        </button>
                    ))}
            </div>
        </>
    );
};
